<template>
  <ServicesSection ref="services"></ServicesSection>
</template>

<script>
  import ServicesSection from "./ServicesSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "ServicesWrapper",
    components: {
      ServicesSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
